// Module
var code = "<manage-categories></manage-categories>";
// Exports
module.exports = code;